var map = {
	"./$GMUSIC-icon.png": 1145,
	"./BAT-icon.png": 1146,
	"./BTC-icon.png": 1147,
	"./BXC-icon.png": 1148,
	"./CC-icon.png": 550,
	"./DistTest-icon.png": 1745,
	"./ETH-icon.png": 1149,
	"./GALA-icon.png": 732,
	"./GALA[ETH]-icon.png": 1746,
	"./GALA[GYRI]-icon.png": 1747,
	"./MTRM-icon.png": 1748,
	"./NODETESTCOIN-icon.png": 1749,
	"./NODETESTCOIN-transparent-icon.png": 1750,
	"./SILK-icon.png": 910,
	"./SILK[GYRI]-icon.png": 1751,
	"./TANK-icon.png": 1150,
	"./TCTESTCOIN-icon.png": 1752,
	"./TEST-icon.png": 1753,
	"./TOWN-icon.png": 1151,
	"./mastercard-icon.png": 548,
	"./simplex-icon.png": 1152,
	"./visa-icon.png": 549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 727;